import axios from '../utils/request';

// 获取跑马灯列表
export function getAnnounceList(params) {
  return axios({
    url: '/announce/list',
    type: 'get',
    params
  })
}

// 新增跑马灯
export function addAnnounce(params) {
  return axios({
    url: '/announce/add',
    type: 'post',
    params
  })
}

// 修改跑马灯
export function updateAnnounce(params) {
  return axios({
    url: '/announce/update',
    type: 'post',
    params
  })
}

// 删除跑马灯
export function deleteAnnounce(params) {
  return axios({
    url: '/announce/del',
    type: 'delete',
    params
  })
}
